import {
	getSearchConfig,
	type TSearchConfigAPIResponse,
} from '@atlassian/search-client/fetch-search-config';

import { createResource } from '@townsquare/router/resources/createResource';
export const searchConfigurationResource: import('packages/router/src/react-resource-router').RouteResource<TSearchConfigAPIResponse> =
	createResource<TSearchConfigAPIResponse>({
		getData: async (_, __) => {
			return await getSearchConfig({})
				.then((data) => {
					return data;
				})
				.catch(() => {
					return {
						resources: [],
						intercomHmac: '',
						siteMetadata: [],
					};
				});
		},
		getKey: () => 'search-configuration-resource-key',
		type: 'SEARCH_CONFIGURATION',
	});
